import { render, staticRenderFns } from "./CardMealActionSwap.vue?vue&type=template&id=485db0a4&scoped=true"
import script from "./CardMealActionSwap.vue?vue&type=script&lang=js"
export * from "./CardMealActionSwap.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "485db0a4",
  null
  
)

export default component.exports